import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { RouteAccessService } from 'src/app/permissions/route-access.service';

@Directive({
  selector: '[appHasPermission]',
  standalone: true,
})
export class HasPermissionDirective {
  private permission?: string | null;
  private requestId = 0;
  private hasView = false;

  constructor(
    private readonly templateRef: TemplateRef<unknown>,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly routeAccessService: RouteAccessService,
  ) {}

  @Input()
  set appHasPermission(permission: string | null | undefined) {
    this.permission = permission;
    void this.updateView();
  }

  private async updateView(): Promise<void> {
    const currentRequestId = ++this.requestId;
    const hasPermission = await this.routeAccessService.hasPermission(
      this.permission ?? undefined,
    );

    if (currentRequestId !== this.requestId) {
      return;
    }

    if (hasPermission && !this.hasView) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
      this.hasView = true;
      return;
    }

    if (!hasPermission && this.hasView) {
      this.viewContainerRef.clear();
      this.hasView = false;
    }
  }
}
